import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { PainSection } from '../components/sales/PainSection';
import { RevealSection } from '../components/sales/RevealSection';
import { OfferSection } from '../components/sales/OfferSection';
import { PricingCTA } from '../components/sales/PricingCTA';
import { FloatingCTA } from '../components/sales/FloatingCTA';
import { Footer } from '../components/sales/Footer';
export function SalesPage() {
  return <main className="w-full font-body" lang="es" data-id="element-142">
      <HeroSection data-id="element-143" />
      <PainSection data-id="element-144" />
      <RevealSection data-id="element-145" />
      <OfferSection data-id="element-146" />
      <PricingCTA data-id="element-147" />
      <Footer data-id="element-148" />
      <FloatingCTA data-id="element-149" />
    </main>;
}